export default {
  postConfirmInvite: {
    url: '/useradmin/confirm_invite/',
    options: {
      method: 'POST',
      credentials: 'omit',
    },
  },
  confirmInviteLink: {
    url: '/useradmin/confirm_invite_link/',
    options: {
      credentials: 'omit',
      method: 'POST',
    },
  },
};
